var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCampaignEnded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 43,
    viewBox: "0 0 68 43",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f78080",
    d: "M.4.511l66.9.1-.1 42.1-66.9-.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffa7a7",
    d: "M4.8 38.211c-1.6-1.5-1.3-4.2-1.2-6.1.1-2.5.1-5.1.2-7.6v-12.5c0-1.8 0-3.7-.2-5.5 0-.5-1.1-5.7-1.1-5.7 1.3-.8 5-.2 6.6-.2h58v32.5c0 2.4-.4 4.9-.3 7.2-6.3 1-13 .3-19.3-.1-6.7-.4-13.4-.6-20.1-.7-6.5-.1-13.4.8-19.8-.2-.9-.1-1.8-.4-2.6-.9l-.2-.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f78080",
    d: "M.4.511l66.9.1-32.2 27.2c-.9.7-2.1.8-3 .1L3.2 5.711.4.511"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc1c1",
    d: "M.4.511l66.9.1-33.3 26L.4.511"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#6a79a6",
    d: "M0 .611v14.3c0 9.5.9 18.4 0 27.9 0 .1.2.1.2.1h58.7c2.7 0 5.4.2 8.1 0h.1c.2 0 .6-.1.6-.3v-42c0-.2-.8-.1-.8.2v42l.6-.3H1.6c-.3 0-.7-.1-.9 0H.6l.2.1V.511c0-.3-.8-.1-.8.1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#6a79a6",
    d: "M67 .511l-11.3 8.8-17.9 14-4.1 3.2.7-.1-11.4-8.8-18.1-14.1L.8.311l-.5.4H59c2.7 0 5.4.2 8.1 0h.1c.3 0 .9-.5.3-.5H8.8c-2.7 0-5.4-.1-8.1 0H.6c-.1 0-.8.2-.5.4l11.4 8.8 18.1 14.1 4.1 3.2c.2.2.5.1.7-.1l11.3-8.8c7.3-5.7 14.7-11.5 22-17.2.3-.2-.5-.2-.7-.1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#6a79a8",
    d: "M28 7.411c-.2 0-.4-.1-.6-.3-.3-.3-.3-.9.1-1.2.2-.1.4-.2.6-.2s.4.1.6.3c.3.3.3.9-.1 1.2-.2.2-.4.3-.6.2m11.3-.5c-.2 0-.4-.1-.6-.3-.3-.3-.3-.9.1-1.2s.9-.2 1.2.1c.1.2.2.4.2.6s-.1.4-.3.6-.4.3-.6.2m-8.4 5.2c-.5 0-1 .4-1 1v.3c.6 1.9 2.3 3.1 4.3 3.1s3.7-1.4 4.2-3.2c.1-.5-.2-1.1-.7-1.2h-6.8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff9c81",
    d: "M25.4 11.511c-.1 1-.8 1.8-1.6 1.7s-1.3-.9-1.2-2c.1-1 .8-1.8 1.6-1.7.7.1 1.3 1 1.2 2m19.6 1.9c-.1 1-.8 1.8-1.6 1.7s-1.3-.9-1.2-2c.1-1 .8-1.8 1.6-1.7s1.3 1 1.2 2"
  })));
}

export default __webpack_public_path__ + "./fonts/campaign-ended.05b6c12274f74f5db65acc578c1d20ef.svg";
export { SvgCampaignEnded as ReactComponent };